import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { attachPushListeners, setPushRouteHandler } from '../utils/pushNotifications';

// Mounts the native push listeners once, app-wide, and turns a notification
// tap into an in-app navigation.
//
// It does NOT ask for permission — see pushNotifications.js rule 2. All this
// does on a device that has never granted permission is register listeners
// that never fire. The ask lives in Settings -> Notifications and in the
// in-context prompt on Messages.
//
// Must be mounted INSIDE the Router (it uses useNavigate) — App.js renders
// <PushBridge /> next to <UpdateBanner />, inside <BrowserRouter>. A tap that
// cold-starts the app can arrive before this mounts, so pushNotifications.js
// buffers the route and setPushRouteHandler drains it on subscribe.
export default function usePushNotifications() {
  const navigate = useNavigate();
  useEffect(() => {
    attachPushListeners();
    setPushRouteHandler(route => {
      // data.route is server-authored (sendPushToUids), always an in-app path
      // like /jobs/<id>/messages. Guarded to a relative path anyway so a
      // malformed payload can never navigate the WebView off-origin.
      if (typeof route === 'string' && route.startsWith('/') && !route.startsWith('//')) {
        navigate(route);
      }
    });
    return () => setPushRouteHandler(null);
  }, [navigate]);
}
